<template>
  <CustomSelect
    class="w-100"
    inputId="daysLimitPicker"
    inputLabel="حداکثر تعداد روز رزرو متوالی با یک استاد (دلخواه)"
    v-model="selectedDays"
    :value="value"
    @input="$emit('input', $event)"
    :customOptions="daysLimitOptions"
  ></CustomSelect>
</template>

<script>
export default {
  emits: ["getSelectedDays"],
  props: {
    defaultSelectedDays: {
      type: [String, Number],
      required: false,
    },
    value: {
      type: [String, Number, null],
      default: null,
    },
  },
  model: {
    prop: "value",
    event: "input",
  },
  mounted() {
    if (this.defaultSelectedDays) {
      this.selectedDays = this.defaultSelectedDays;
    }
  },
  watch: {
    selectedDays: {
      handler(val) {
        this.$emit("getSelectedDays", val);
      },
    },
  },
  data() {
    return {
      selectedDays: null,
      daysLimitOptions: [
        {
          text: "بدون محدودیت",
          value: null,
        },
        {
          text: "1 هفته",
          value: 7,
        },
        {
          text: "2 هفته",
          value: 14,
        },
        {
          text: "3 هفته",
          value: 21,
        },
        {
          text: "1 ماه",
          value: 30,
        },
      ],
    };
  },
  components: {
    CustomSelect,
  },
};
import CustomSelect from "@/views/components/Utils/CustomSelect.vue";
</script>
